import { useFormContext } from 'react-hook-form';
import { useTaskCategories } from 'app/agriculture/queries/tasks/useTaskCategories';
import { Select } from 'app/agriculture/forms/components/Select/Select';
import { SuspenseWrapper } from 'app/agriculture/components/SuspenseWrapper/SuspenseWrapper';
import { useMemo } from 'react';

function TaskCategoryDropdownWithoutSuspense() {
    const taskCategories = useTaskCategories();
    const formController = useFormContext();
    const options = useMemo(
        () =>
            [...taskCategories.values()].map(({ name }) => ({
                id: name,
                name,
            })),
        [taskCategories],
    );

    return (
        <div className="TaskCategoryDropdown">
            <Select
                fieldName="category"
                noun="Category"
                options={options}
                formController={formController}
            />
        </div>
    );
}

export function TaskCategoryDropdown() {
    return (
        <SuspenseWrapper>
            <TaskCategoryDropdownWithoutSuspense />
        </SuspenseWrapper>
    );
}
